<div class="flex flex-col h-full bg-white" [ngClass]="{ 'dark:bg-surface-1': !isMobile() }">
  <!-- Chat Content Area -->
  <div class="flex-1 min-h-0">
    @if (chatMessages().length === 0) {
    <div class="h-full overflow-y-auto">
      <div class="px-4 py-5 h-full">
        <!-- Empty State / Welcome -->
        <div class="flex flex-col items-center justify-center h-full text-center">
          <div class="w-12 h-12 flex items-center justify-center text-slate-400 mb-3"
            [ngClass]="{ 'dark:text-slate-500/50': !isMobile() }">
            <app-icon name="sparkles" [size]="48" />
          </div>
          <h3 class="text-sm font-normal text-slate-600 max-w-[240px] leading-relaxed"
            [ngClass]="{ 'dark:text-slate-300': !isMobile() }">
            What would you like me to help you with today?
          </h3>
        </div>
      </div>
    </div>
    } @else {
    <!-- Chat Messages with scroll handled by component -->
    <app-chatbot-message-list class="h-full block" [messages]="chatMessages()" [enableScrollContainer]="true"
      scrollContainerClass="h-full" [isTyping]="isTyping()" [typingSpeedWPM]="300" [stopAutoScroll]="false"
      [layoutMode]="layoutMode" (fullscreenChartRequested)="fullscreenChartRequested.emit()">

      <!-- Remaining Suggestions projected into footer -->
      <div footer class="px-2 pb-4">
        @if (aiSuggestions().length > 0 && !isTyping()) {
        <div class="w-full flex flex-col gap-2 mt-4">
          @for (suggestion of aiSuggestions(); track suggestion) {
          <button (click)="sendQuery(suggestion)"
            class="flex items-start gap-2 px-3 py-2 rounded-lg hover:bg-slate-100 transition-all text-slate-700 group text-left cursor-pointer"
            [ngClass]="{ 'dark:hover:bg-white/5 dark:text-slate-300': !isMobile() }">
            <app-icon name="undo2" [size]="14"
              class="text-slate-700 rotate-90 mt-0.5 flex-shrink-0"
              [ngClass]="{ 'dark:text-slate-500 group-hover:text-purple-500 dark:group-hover:text-white': !isMobile(), 'group-hover:text-purple-500': isMobile() }" />
            <span class="text-xs font-medium">{{ suggestion }}</span>
          </button>
          }
        </div>
        }
      </div>
    </app-chatbot-message-list>
    }
  </div>

  <!-- Suggestion Pills - Fixed above input (only show when no messages) -->
  @if (chatMessages().length === 0) {
  <div class="px-4 pb-2 2xl:pb-5 bg-white" [ngClass]="{ 'dark:bg-surface-1': !isMobile() }">
    <div class="w-full flex flex-col gap-1 2xl:gap-2 max-h-[160px] overflow-y-auto custom-scrollbar">
      @for (suggestion of aiSuggestions(); track suggestion) {
      <button (click)="sendQuery(suggestion)"
        class="flex items-start gap-2 px-2.5 py-1 2xl:px-3 2xl:py-2 rounded-lg hover:bg-slate-100 transition-all text-slate-700 group text-left cursor-pointer shrink-0"
        [ngClass]="{ 'dark:hover:bg-white/5 dark:text-slate-300': !isMobile() }">
        <app-icon name="undo2" [size]="14"
          class="text-slate-700 rotate-90 mt-0.5 flex-shrink-0"
          [ngClass]="{ 'dark:text-slate-500 group-hover:text-purple-500 dark:group-hover:text-white': !isMobile(), 'group-hover:text-purple-500': isMobile() }" />
        <span class="text-xs font-medium line-clamp-2">{{ suggestion }}</span>
      </button>
      }
    </div>
  </div>
  }

  <div class="px-4 pt-2 2xl:pt-4 pb-17 bg-white" [ngClass]="{ 'dark:bg-surface-1': !isMobile() }">
    <div
      class="relative bg-slate-50 rounded-2xl px-3.5 py-3 pr-12 border border-slate-200 group transition-all min-h-[100px] flex items-start shadow-inner"
      [ngClass]="{ 
        'dark:bg-surface-1 dark:border-slate-800/60 focus-within:border-sky-400 dark:focus-within:border-purple-500/50': !isMobile(),
        'focus-within:border-sky-400': isMobile()
      }">
      <textarea [placeholder]="chatType === 'CALL_AUDIT_HISTORY' ? 'What would you like to know?' : 'Ask Prism AI'"
        rows="4" [ngModel]="userInput()" (ngModelChange)="userInput.set($event)"
        (keydown.enter)="$event.preventDefault(); sendQuery(userInput())" [disabled]="isTyping()"
        class="w-full bg-transparent border-none focus:ring-0 text-slate-700 placeholder:text-slate-400 resize-none text-sm p-0 outline-none disabled:opacity-50 disabled:cursor-not-allowed"
        [ngClass]="{ 'dark:text-slate-200 dark:placeholder:text-slate-500': !isMobile() }"></textarea>

      <!-- Send Button -->
      <button (click)="sendQuery(userInput())" [disabled]="isTyping()"
        class="absolute bottom-2 right-2 w-9 h-9 rounded-full border-2 border-l-purple-500 border-r-cyan-500 border-t-cyan-500 border-b-cyan-500 flex items-center justify-center text-white shadow-lg hover:shadow-xl hover:scale-110 active:scale-95 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:shadow-none cursor-pointer"
        [ngClass]="{ 'dark:border-l-pink-400 dark:border-r-sky-400 dark:border-t-sky-400 dark:border-b-sky-400': !isMobile() }">
        <app-icon class="text-purple-500" [ngClass]="{ 'dark:text-pink-400': !isMobile() }" name="arrowRight" [size]="18" />
      </button>
    </div>
  </div>
</div>